<template>
  <div class="page-container" id="page-container">
    <div class="page-title padding pb-0 ">
      <h2 class="text-md mb-0">{{ $t('message.Lawyer.header') }}</h2>
    </div>
    <div class="padding">
      <div class="row">
        <div v-if="!lawyersLoaded" class="h-100 d-flex justify-content-center align-items-center">
          <img alt="Vue logo" src="@/assets/img/loading.gif" width="100px" height="100px">
        </div>

        <div v-else class="col-md-12">
          <div class="card card-form">
            <div class="card-body">
              <div class="form-section-header">{{ $t('message.Lawyer.header') }}</div>

                <b-row class="my-1">
                  <b-col sm="3">
                    <label class="col-form-label">Name <var class="text-danger">*</var></label>
                  </b-col>

                  <b-col sm="9">
                    {{lawyer.name}}
                  </b-col>
                </b-row>

                <b-row class="my-1">
                  <b-col sm="3">
                    <label class="col-form-label">Email <var class="text-danger">*</var></label>
                  </b-col>

                  <b-col sm="9">
                    {{lawyer.email}}
                  </b-col>
                </b-row>

                <b-row class="my-1">
                  <b-col sm="3">
                    <label class="col-form-label">Contact email <var class="text-danger">*</var></label>
                  </b-col>

                  <b-col sm="9">
                    {{lawyer.email_contact}}
                  </b-col>
                </b-row>

                <b-row class="my-1">
                  <b-col sm="3">
                    <label class="col-form-label">Url <var class="text-danger">*</var></label>
                  </b-col>

                  <b-col sm="9">
                    {{lawyer.url}}
                  </b-col>
                </b-row>

                <b-row class="my-1">
                  <b-col sm="3">
                    <label class="col-form-label">Url label <var class="text-danger">*</var></label>
                  </b-col>

                  <b-col sm="9">
                    {{lawyer.url_label}}
                  </b-col>
                </b-row>

                <b-row class="my-1">
                  <b-col sm="3">
                    <label class="col-form-label">Web <var class="text-danger">*</var></label>
                  </b-col>

                  <b-col sm="9">
                    {{lawyer.web}}
                  </b-col>
                </b-row>

                <b-row class="my-1">
                  <b-col sm="3">
                    <label class="col-form-label">Address <var class="text-danger">*</var></label>
                  </b-col>

                  <b-col sm="9">
                    {{lawyer.address}}
                  </b-col>
                </b-row>

                <b-row class="my-1">
                  <b-col sm="3">
                    <label class="col-form-label">Phone <var class="text-danger">*</var></label>
                  </b-col>

                  <b-col sm="9">
                    {{lawyer.phone}}
                  </b-col>
                </b-row>

                <b-row class="my-1">
                  <b-col sm="3">
                    <label class="col-form-label">Photo</label>
                  </b-col>

                  <b-col sm="9">
                    <b-img v-if="lawyer.photo && lawyer.photo.url" thumbnail fluid :src="lawyer.photo.url" />
                  </b-col>
                </b-row>


                <b-row class="my-1">
                  <b-col sm="3">
                    <label class="col-form-label">{{ $t('message.Lawyer.default') }}</label>
                  </b-col>

                  <b-col sm="9">
                    {{lawyer.default}}
                  </b-col>
                </b-row>

              <div class="form-buttons">
                <button type="submit" class="btn btn-success" @click="$router.go(-1)">{{ $t('message.return') }} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {LAWYER_REQUEST_BY_ID} from '@/store/actions/lawyers';

  export default {
    name: "LawyerView",

    data() {
      return {
        lawyer: {
          name: null,
          description: ''
        },
      }
    },

    mounted() {
      this.getAuthor(this.$route.params.id);
    },

    methods: {
      proceed() {
        this.$validator.validateAll().then(result => {
          if (!result) {
            this.$swal({
              title: 'Error!',
              text: this.$t("message.Guideline.fillRequiredFields"),
              type: 'error',
              confirmButtonText: 'OK'
            });

            this.showValidateErrors = true;
          } else {
            if (this.author.id == undefined) {
              return this.saveAuthor();
            }

            return this.updateAuthor();
          }
        });
      },

      async getAuthor(id) {
        if (id != undefined) {
          this.$store.dispatch(LAWYER_REQUEST_BY_ID, id).then(lawyer => {
            this.lawyer = lawyer;
          }).catch(err => {
            console.log(err);
          })
        }
      }
    },
  }
</script>


<style scoped>

</style>